/**
 * oggetto specifico di REST per SHAPER-TEST
 */
import AppActions from '../app/app_actions'
import { AppConstants } from '../constants/AppConstants.js';
import { store } from '../store.js'
import { WebRest } from 'arm-common';

/**
 * classe Rest basata su WebRest
 */
class Rest extends WebRest {
    /*
     */
    constructor() {
        super(
            AppConstants.REST_SERVER, //
            AppConstants.REST_BASE_URL, //
            ["account/login", "authentication/loginbo"], // to skip

            // recover jsessionId
            () => {
                let app = store.getState().app;
                return app.jsessionId;
            },

            // loading, show loader
            (dispatch) => {
                dispatch(AppActions.showLoader());
            },

            // end load, hide loader
            (dispatch) => {
                dispatch(AppActions.hideLoader());
            },

            // handle error message
            (dispatch, message, statusCode, options, stacktrace) => {
                dispatch(AppActions.addNotify('DANGER', message));
                // TODO discerne sullo status code per decidere se visualizzare un errore bloccante o meno
                // es, per sessione scaduta visualizzare altro...
                /* let mesg = "<div style='font-size: 150%'>" + message + "</div>";
                 if (stacktrace) {
                     if (stacktrace.startsWith("<html>")) {
                         let stpos = stacktrace.toLowerCase();
                         mesg += "<hr /><div class='__htmlError'>";
                         // let hasStyle = stpos.indexOf("<style");
                         // if (hasStyle > 0) {
                         //    mesg += stacktrace.substring(hasStyle, stpos.indexOf("</style>", hasStyle) +
                         //         "</style>".length);
                         // }
                         let stbody = stpos.indexOf("<body");
                         stbody = stpos.indexOf(">", stbody) + 1;
                         let body = stacktrace.substring(stbody, stpos.lastIndexOf("</body>"));
                         console.log("body error html:", body);
                         mesg += body;
                         mesg += "</div>"
                     } else {
                         mesg += "<hr /><div><pre style='max-height: 65vh;" +
                             " overflow-y: auto; " +
                             " width: 95%;" +
                             " border: 1px solid #c00;'>" + stacktrace + "</pre></div>";
                     }
 
                 }
 
                 console.warn("REST SHAPER ERROR", mesg);
 
 
                 if (statusCode < 200 || (statusCode >= 400 && statusCode < 413) || statusCode >= 500)
                     __showInternalError(mesg, "Errore di comunicazione con il back-end - status code " + statusCode);
                     */
            },

            // do logout
            (dispatch) => {
                dispatch({
                    type: 'LOGOUT'
                });
            },

            // path iniziale per chiamate stubs
            "./stubs/",

            // recover serverId
            () => {
                let app = store.getState().app;
                return app.serverid;
            },

        )
    }

    newDownloadFileStreamPOST = function (path, body, dispatch, options) {
        this._resetExpiredSessionHandler(dispatch, options);
        if (path === undefined || path === null) {
            console.error("WebRest.downloadFileStreamPOST: cannot have path parameter null/undefined");
            return {};
        }
        let url = this.createRestLink(path, options, this.pathsToSkip);
        console.log("[WebRest.downloadFileStreamPOST]: " + url);
        let temp = null;
        if (body !== null) {
            temp = JSON.stringify(body);
        }
        let opts = Object.assign({}, {
            contentType: 'application/json; charset=utf-8',
        }, options);
        this._loading(url, dispatch, opts);
        // Use XMLHttpRequest instead of Jquery jqueryajax
        let xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            console.log("[WebRest.downloadFileStreamPOST] onreadystatechange " + xhr.readyState);
            if (xhr.readyState === 4 && xhr.status === 200) {
                let contentType = xhr.getResponseHeader("Content-Type");
                console.log("[WebRest.downloadFileStreamPOST] contentType: " + contentType);
                let contentDisposition = xhr.getResponseHeader("Content-Disposition");
                console.log("[WebRest.downloadFileStreamPOST] contentDisposition: " + contentDisposition);
                let fileName = this._getFileNameByContentDisposition(contentDisposition);
                // Trick for making downloadable link
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(xhr.response);
                // Give filename you wish to download
                link.download = fileName;
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                //remove the link when done
                document.body.removeChild(link);
            }
        };
        xhr.onloadend = () => {
            console.log("[WebRest.downloadFileStreamPOST] onloadend ");
            //The loadend event is fired when a request has completed, whether successfully (after load) or unsuccessfully (after abort or error).
            this._endload(url, dispatch, options);
        }
        // Post data to URL which handles post request
        xhr.open("POST", url);
        xhr.setRequestHeader("Content-Type", opts.contentType);
        // You should set responseType as blob for binary responses
        xhr.responseType = 'blob';
        xhr.send(temp);
        return Promise.resolve();
    }



}

export default new Rest;